import { Space, MenuProps, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useState } from "react";
import { DropdownMenuProps } from "./dropdown-menu-types";
import { StyledButton, MenuContainer } from "./style-component";

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
    defaultLabel = 'Más reciente',
    items = [
        { key: '1', label: 'Más reciente' },
        { key: '2', label: 'Más antiguo' },
        { key: '3', label: 'Próximo a expirar' },
        { key: '4', label: 'Último a expirar' },
    ],
    onSelect,
}) => {
    const [selectedLabel, setSelectedLabel] = useState(defaultLabel);

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        const selected = items?.find(item => item?.key === e.key);
        if (selected && 'label' in selected) {
            setSelectedLabel(selected.label as string);
            onSelect?.(e.key, selected.label as string);
        }
    };

    return (
        <Dropdown 
            menu={{ items, onClick: handleMenuClick }}
            dropdownRender={(menu) => (
                <MenuContainer>
                    {menu}
                </MenuContainer>
            )}
        >
            <StyledButton>
                <Space>
                    {selectedLabel}
                    <DownOutlined />
                </Space>
            </StyledButton>
        </Dropdown>
    );
};
